(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href$="#shopifyReshowConsentBanner"]');
    if (!link || new URLSearchParams(location.search).get('pb') !== '0') return;
    if (window.privacyBanner?.showPreferences) {
      event.preventDefault();
      window.privacyBanner.showPreferences();
    }
  });
})();